import React from "react";
import { usePublicContent } from "../i18n/PublicContentContext";

export default function WhatsAppFloat() {
  const { waLink, contact } = usePublicContent();
  if (contact && contact.wa_float_enabled === false) return null;
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] shadow-xl shadow-black/30 transition-transform duration-300 group-hover:scale-110">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="white" aria-hidden="true">
          <path d="M16.004 3.2c-7.06 0-12.79 5.73-12.79 12.79 0 2.255.59 4.457 1.712 6.4L3.2 28.8l6.57-1.717a12.74 12.74 0 0 0 6.234 1.588h.005c7.06 0 12.79-5.73 12.79-12.79 0-3.418-1.33-6.632-3.746-9.05A12.706 12.706 0 0 0 16.004 3.2zm0 23.11h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.01 1.05 1.07-3.91-.252-.4a10.57 10.57 0 0 1-1.62-5.65c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.107 7.52 3.117a10.57 10.57 0 0 1 3.112 7.52c0 5.867-4.77 10.637-10.63 10.637zm5.834-7.965c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.848-1.592-1.895-1.779-2.215-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.737-.987-2.377-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.146 3.093 1.306 3.307.16.213 2.253 3.44 5.46 4.824.763.33 1.358.527 1.822.674.766.244 1.463.21 2.014.127.614-.092 1.892-.773 2.159-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z" />
        </svg>
      </span>
    </a>
  );
}
